// extracted by mini-css-extract-plugin
module.exports = {"title":"Terms_title__2f_Ac","bg":"Terms_bg__MgEIa","main":"Terms_main__2difM","content":"Terms_content__1z7l3","paragraph-title":"Terms_paragraph-title__1Dl7K"};